import * as React from "react";
import { MyAccountService } from "./myaccount-service";
import { Props } from "../../types/global";
import { formatDate } from "../utils";
import { messageDialog } from "../dialogs/MessageDialog";
import t from "../i18n";
import SingleClickLink from "../Controls/SingleClickLink";
import { dialogService } from "react-api-dialog";
import { btnStyles } from "../_styles/button";
import classNames from "classnames";
import { css } from "emotion";

declare type TicketState = {
    ticketId: number,
    newComment: string,
    comments: any[],
    ticket: any,
}
export default class SupportTicketEdit extends React.Component<Props, TicketState> {
    readonly state: TicketState = {
        ticketId: 0,
        newComment: "",
        comments: [],
        ticket: []
    };

    async componentDidMount() {
        this.fetchComments();
    }
    fetchComments = async () => {
        const ticketId = this.props.location.query.ticketId;
        const response = await MyAccountService.fetchComments(ticketId);
        if (!response) return;
        if (response.responseCode !== 0) {
            messageDialog("Error occured!", t.menu("support_tickets"));
        }
        this.setState({
            ticketId: ticketId,
            comments: response.payLoad.comments,
            ticket: response.payLoad.ticket
        });
    }
    isOpen() {
        return (this.state.ticket && this.state.ticket.status && this.state.ticket.status !== 'closed');
    }
    handleNewCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newCom = e.target.value;
        this.setState({ newComment: newCom });
    }

    handleCancel = () => {
        this.props.history.push('/tickets');
    }

    submit = async () => {
        if (!this.state.newComment) {
            messageDialog(t.myaccount("error_description"), t.menu("support_tickets"));
            return;
        }
        dialogService.showPreloader();
        const response = await MyAccountService.postComment(this.state.ticketId, this.state.newComment);
        await dialogService.hidePreloader();
        if (response.responseCode === 0) {
            messageDialog(t.myaccount("comments_posted"), t.menu("support_tickets"));
            await this.fetchComments();
            this.setState({ newComment: '' });
        }
        else {
            messageDialog(response.responseMessage || "", t.menu("support_tickets"));
        }
    }
    renderCommentBlock(comment: any) {
        return (
            <div key={comment.id}>
                <div>
                    <span className="fa-stack" style={{ fontSize: "12px" }}>
                        <i className="fa fa-circle fa-stack-2x" />
                        <i className="fa fa-user fa-stack-1x fa-inverse" />
                    </span>
                    <span style={{ paddingLeft: 5 }}>
                        <strong>{comment.author_name}</strong>
                    </span>
                    <span style={{ fontStyle: "italic", fontSize: 13 }}> {formatDate(comment.created_at)}</span>
                </div>
                <div style={{ paddingTop: "10px", paddingLeft: "30px" }}>
                    <div>{comment.body}</div>
                </div>
                <hr />
            </div>
        )
    }
    renderNewCommentBlock() {
        if (!this.isOpen()) return <React.Fragment />;
        return (
            <div>
                <div>{t.myaccount("new_comment")}</div>
                <div style={{ marginTop: 5 }}>
                    <textarea name="newComment" id="newComment" rows={10} style={{ width: "100%" }} placeholder={t.myaccount("post_comment")} value={this.state.newComment} onChange={this.handleNewCommentChange} />
                </div>
                <div style={{ textAlign: "right" }}>
                    <a className={classNames(['button', css(btnStyles.white)])} onClick={this.handleCancel}>{t.common("cancel_button")}</a>
                    <SingleClickLink className={classNames(['button', css(btnStyles.default)])} onClick={this.submit}>{t.common("submit")}</SingleClickLink>
                </div>
            </div>
        );
    }
    render() {
        return (
            <div className="container small-gutter" style={pageWidth}>
                <div className="form-group form-title">
                    <h2>{t.myaccount("ticeket_detail")}</h2>
                </div>
                <div className="block">
                    {this.state.comments.map(com => {
                        return this.renderCommentBlock(com);
                    })}
                    <div>
                        {this.renderNewCommentBlock()}
                    </div>
                </div>

            </div>
        );
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}